import { LookupMappingInformation } from '../interfaces/credit-application-config.interface';
import { IDescriptionValuePair } from '../interfaces/config.interface';

import { UntypedFormGroup } from '@angular/forms';

export function getLookupMappings(lookupMappingInfo: LookupMappingInformation[], lookupName: string): IDescriptionValuePair[] {
  if (lookupMappingInfo) {
    const lookUpResult = lookupMappingInfo.filter(x => x.LookupName === lookupName);
    const values = lookUpResult.length > 0 ? lookUpResult[0].Mappings : null;
    switch (lookupName) {
      case 'MonthsAtAddressType':
        return [...values].splice(0, 12);
      case 'IncomePeriodIntervalType':
        return [...values].map(e => ({ Description: e.Description, Value: e.Description, Details: e.Details }));
      default:
        return values;
    }
  }

  return null;
}


export function validateBothNotZero(c: UntypedFormGroup): { [key: string]: boolean } | null {
  const keys = Object.keys(c.controls);
  const first = c.get(keys[0]);
  const second = c.get(keys[1]);


  if (first && second && first.value !== null && second.value !== null &&
    ((first.value === '0' || first.value === 0) && (second.value === '0' || second.value === 0))) {
    return { invalidselection: true };
  }

  if ((first && first.pristine) || (second && second.pristine)) {
    return null;
  }
  return null;
}

export function validateAllFormFields(form: UntypedFormGroup) {
  Object.keys(form.controls).forEach((key) => {
    if (form.get(key) && form.get(key).value) {
      form.get(key).markAsTouched();
    }
  });
}

export function isIEorEdge() {
  return /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
}

export function hideCTA() {
  /* istanbul ignore next */
  const headerMain = document.getElementsByClassName('credit-app-cta-section') as HTMLCollectionOf<HTMLElement>;
  /* istanbul ignore next */
  if (headerMain.length > 0) {
    headerMain[0].style.display = 'none';
  }

}

export function showCTA() {
  const headerMain = document.getElementsByClassName('credit-app-cta-section') as HTMLCollectionOf<HTMLElement>;
  if (headerMain.length > 0) {
    headerMain[0].style.display = 'block';
  }

}
/* istanbul ignore next */
export function isMobile() {
  return window.innerWidth < 767 || (window.innerWidth > 768 && window.innerHeight < 480);
}

export function getBackButton() {
  const prev = document.querySelector('.buynow-move-prev');
  if (prev) {
    const style = window.getComputedStyle(prev);
    if (style.display === 'none') {
      document.querySelector('ngx-ui-loader').className = 'noBackButton';
    } else {
      document.querySelector('ngx-ui-loader').className = 'isBackButton';
    }
  }
}
